export default class GetLicenceInformationResponseEntry {
  Product!: string;
  SerialNumber!: string;
  Company!: string;
  WebCopies!: string;
  WebCopiesInUse!: string;
  Optional!: string;
  ExpiryDate!: string;
}
